import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Alert, AlertIcon, Box, Spinner, useToast } from "@chakra-ui/react";
import Navbar from "./Navbar";
import WatermarkBackground from "./components/WatermarkBackground";
import { getLineRequest } from "./services/PlacingAPI";
import { showApiErrorToast } from "./utils/showApiToast";
import CarrierLineRequestView from "./components/placing/CarrierLineRequestView";

/** A line request (Order) sent to one of the carrier's parties. */
const PlacingLineRequestPage = () => {
  const { lineRequestId } = useParams();
  const toast = useToast();
  const [lineRequest, setLineRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setLineRequest(await getLineRequest(lineRequestId));
      setError(null);
    } catch (err) {
      setError(err);
      showApiErrorToast(toast, err, { title: "Couldn't load line request" });
    } finally {
      setLoading(false);
    }
  }, [lineRequestId, toast]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Box position="relative" minHeight="100vh">
      <WatermarkBackground />
      <Navbar />
      <Box p={6} maxW="1400px" mx="auto">
        {loading ? (
          <Spinner />
        ) : error || !lineRequest ? (
          <Alert status="error"><AlertIcon />{error?.message || "Line request not found."}</Alert>
        ) : (
          <CarrierLineRequestView lineRequest={lineRequest} onChanged={load} />
        )}
      </Box>
    </Box>
  );
};

export default PlacingLineRequestPage;
